import Vue from 'vue'
import Vuex from 'vuex'
 import axios from 'axios'

 import files from './files'
// import modals from './modals'
// import tasks from './tasks'
 import users from './users'
// import articles from './articles'
// import blogCategory from './blogCategory'


Vue.use(Vuex)

export default axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.token
  }
})

export const store = new Vuex.Store({

    modules: {
         files,
        // modals,
        // blogCategory,
        // tasks,
         users,
        // articles,
    }

})





// WEBPACK FOOTER //
// ./src/store/store.js